export { CarouselType, ContentSourceType, EntityName, MyListAssetType, PROVIDER, SectionId, Source } from './normalizr/constants.js';
export { CarouselEntity, ChannelEntity, ContentEntity, PageEntity, PageEntityV4, ScheduleEntity, SeasonEntity, ShowEntity } from './normalizr/entities.js';
export { DRMSObject, Image, ImagesCollection, MatchTeam, Scores, Streaming, Team, URLsObject, WithImages } from './normalizr/interfaces.js';
export { addRatioToImages, completeChildrenProps, convertChildrenArrayToObject, convertImageUrlToImageCollection, convertImagesArrayToObject, genericConvertImagesArrayToObject, normalizeGenres, sortChildren, typeToEntityName } from './normalizr/utils.js';
import 'query-string';
import '@dtvgo/typed-normalizr';
import '@dtvgo/constants';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';

const ClientType = {
  STB: "1",
  LEGACY_STB: "2",
  ANDROID_TABLET: "3",
  ANDROID_MOBILE: "4",
  ANDROID_TV: "5",
  IOS_MOBILE: "7",
  IOS_TABLET: "8",
  TVOS_APPLE_TV: "9",
  APPLE_TV: "9",
  // Retrocompatibility
  WINDOWS_TABLET: "10",
  PLAYSTATION: "11",
  XBOX: "12",
  CHROMECAST: "13",
  SMART_TV: "14",
  TV: "14",
  // Retrocompatibility
  PC: "15",
  DESKTOP: "15",
  // Retrocompatibility
  MAC: "16",
  ROKU: "100",
  FIRE: "101",
  SAMSUNG: "102",
  LG: "103"
};
const VERSION_MW_1 = "v1";
const FORGE_ROCK_PROVIDER = "forgerock";
const AppEnvironment = {
  local: "dev",
  dev: "dev",
  rt: "alpha",
  preprod: "beta",
  prod: "prd",
  production: "prd"
};

export { AppEnvironment, ClientType, FORGE_ROCK_PROVIDER, VERSION_MW_1 };
//# sourceMappingURL=index.js.map
